import React, { useEffect, useState } from "react";

const STEPS = [
  "Анализируем бренд и формируем концепцию...",
  "Создаём промпт для генерации...",
  "Генерируем варианты баннеров...",
  "Финальная обработка...",
];

function GenerationLoader({ currentStep }) {
  const [activeStep, setActiveStep] = useState(0);

  useEffect(() => {
    if (currentStep) {
      const idx = STEPS.findIndex((s) => s === currentStep);
      if (idx !== -1) setActiveStep(idx);
    }
  }, [currentStep]);

  useEffect(() => {
    const interval = setInterval(() => {
      setActiveStep((prev) => (prev < STEPS.length - 1 ? prev + 1 : prev));
    }, 2500);
    return () => clearInterval(interval);
  }, []);

  return (
    <div className="aic-loader">
      <div className="aic-loader__animation">
        <div className="aic-loader__rings">
          <div className="aic-loader__ring aic-loader__ring--1" />
          <div className="aic-loader__ring aic-loader__ring--2" />
          <div className="aic-loader__ring aic-loader__ring--3" />
        </div>
        <div className="aic-loader__icon">
          <svg width="32" height="32" viewBox="0 0 24 24" fill="none">
            <path d="M12 2L15.09 8.26L22 9.27L17 14.14L18.18 21.02L12 17.77L5.82 21.02L7 14.14L2 9.27L8.91 8.26L12 2Z" fill="#3f73f9"/>
          </svg>
        </div>
      </div>

      <h3 className="aic-loader__title">ИИ создаёт ваши баннеры</h3>
      <p className="aic-loader__current">{currentStep || STEPS[activeStep]}</p>

      <div className="aic-loader__steps">
        {STEPS.map((step, i) => (
          <div
            key={i}
            className={`aic-loader__step ${i <= activeStep ? "aic-loader__step--done" : ""} ${i === activeStep ? "aic-loader__step--active" : ""}`}
          >
            <div className="aic-loader__step-dot">
              {i < activeStep && (
                <svg width="10" height="10" viewBox="0 0 10 10" fill="none">
                  <path d="M2 5l2 2 4-4" stroke="#fff" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round"/>
                </svg>
              )}
            </div>
            <span>{step}</span>
          </div>
        ))}
      </div>
    </div>
  );
}

export default GenerationLoader;
